import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { SvcUserAvatarModule } from '@solvace/component/svc-user-avatar';
import { SvcDialogsModule } from '@solvace/component/svc-dialogs';
import { SvcReactionComponent } from './svc-reaction.component';
import { SvcTotalReactionsComponent } from './svc-total-reactions/svc-total-reactions.component';
import { SvcReactionAnimationComponent } from './svc-reaction-animation/svc-reaction-animation.component';
import { ModalTotalReactionsComponent } from './modal/modal-total-reactions/modal-total-reactions.component';

@NgModule({
  declarations: [
    SvcReactionComponent,
    SvcReactionAnimationComponent,
    SvcTotalReactionsComponent,
    ModalTotalReactionsComponent,
  ],
  imports: [
    LibSharedCommonModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    SvcDialogsModule,
    SvcUserAvatarModule,
    TranslocoModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [
    SvcReactionComponent,
    SvcTotalReactionsComponent,
    ModalTotalReactionsComponent,
  ],
})
export class SvcReactionModule { }
